/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The text is repeated entirely in your browser; nothing is uploaded.`)
};

const es_tr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. El texto se repite completamente en tu navegador; nada se carga.`)
};

const de_tr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Der Text wird vollständig in Ihrem Browser wiederholt; es wird nichts hochgeladen.`)
};

const nl_tr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. De tekst wordt volledig in je browser herhaald; niets wordt geüpload.`)
};

const fr_tr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Le texte est répété entièrement dans votre navigateur; rien n'est téléchargé.`)
};

const it_tr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Il testo viene ripetuto interamente nel tuo browser; nulla viene caricato.`)
};

const pt_br2_tr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. O texto é repetido inteiramente no seu navegador; nada é enviado.`)
};

const pt_tr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. O texto é repetido inteiramente no seu navegador; nada é enviado.`)
};

const ja_tr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。テキストはブラウザ内で完全に繰り返されます。何もアップロードされません。`)
};

const zh_tr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。文本的重复完全在你的浏览器中进行，不会上传任何内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tr_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tr_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tr_faq3_a", locale)
	if (locale === "en") return en_tr_faq3_a(inputs)
	if (locale === "es") return es_tr_faq3_a(inputs)
	if (locale === "de") return de_tr_faq3_a(inputs)
	if (locale === "nl") return nl_tr_faq3_a(inputs)
	if (locale === "fr") return fr_tr_faq3_a(inputs)
	if (locale === "it") return it_tr_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_tr_faq3_a(inputs)
	if (locale === "pt") return pt_tr_faq3_a(inputs)
	if (locale === "ja") return ja_tr_faq3_a(inputs)
	return zh_tr_faq3_a(inputs)
};